module.exports = __webpack_public_path__ + "img/V6.e5009c52.jpg";